import { AMLService, AMLProvider, HttpService } from '@lk/api'

export const makeAMLService = (http: HttpService, baseUrl: string): AMLService =>
  new AMLService(new AMLProvider(http, baseUrl))
